module.exports = __webpack_public_path__ + "img/video.af5d509f.svg";